import 'whatwg-fetch';

export const postParticipant = (data) => (
  (dispatch) => {
    dispatch({type: 'PARTICIPANT_REGISTER_PENDING'});
    fetch('https://docs.google.com/forms/d/e/1FAIpQLSeiwaBHy4ij2j6ECneM6kG6A_JvekRfKiiVasnDpDeZ1yj0kw/formResponse', {
      method: 'post',
      body: data
    })
      .then(response => response.json())
      .then(json => {
        dispatch({
          type: 'PARTICIPANT_REGISTER_DONE'
        });
      })
      .catch(err => {
        console.log(err);
        dispatch({
          type: 'PARTICIPANT_REGISTER_DONE'
        });
      })
  }
);

export const postSponsor = (data) => (
  (dispatch) => {
    dispatch({type: 'SPONSOR_REGISTER_PENDING'});
    fetch('https://docs.google.com/forms/d/e/1FAIpQLSekRjCj6_RIAgkzsdcBh7LzLBk33dPNOBmwWKoU_qgM6fKOhQ/formResponse', {
      method: 'post',
      body: data
    })
      .then(response => response.json())
      .then(json => {
        dispatch({
          type: 'SPONSOR_REGISTER_DONE'
        });
      })
      .catch(err => {
        console.log(err);
        dispatch({
          type: 'SPONSOR_REGISTER_DONE'
        });
      })
  }
);



// WEBPACK FOOTER //
// ./src/actions/google-form-action.js